module.exports = __webpack_public_path__ + "img/icon-language-tab.aa3e35b8.png";